module.exports = __webpack_public_path__ + "img/check.dfcec944.svg";